import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Form } from 'antd';
import s from './s.module.less';
import { EMPTY_PLACEHOLDER } from 'constants/common';
import SparklesIcon from 'assets/common/sparkles.png';
import AiTextEditor from 'components/AI/AiTextEditor';
import { EAIEditorType } from 'types/ai';
import { IBackgroundInfo } from 'types/newUniprofile';

interface Props {
    initValue?: string;
    isEditing?: boolean;
    updateFn: (data: Partial<IBackgroundInfo>) => Promise<void>;
    conversationId?: string;
}

const Treatment = forwardRef((props: Props, ref) => {
    const { isEditing, initValue, updateFn, conversationId } = props;
    const [form] = Form.useForm();

    useEffect(() => {
        if (initValue) {
            form.setFieldsValue({
                treatmentPhilosophy: initValue,
            });
        }
    }, [initValue]);

    const onSubmit = async () => {
        try {
            const values = await form.validateFields();
            await updateFn({
                treatmentPhilosophy: values.treatmentPhilosophy,
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    useImperativeHandle(ref, () => ({
        onSubmit,
    }));

    const renderEditing = () => {
        return (
            <>
                <div className={s.formItemLabel}>Treatment philosophy</div>
                <div className={s.subLabel}>Write a few sentences about how you treat patients, and what values to you the most as a provider</div>
                <div className={s.tips}>
                    <img src={SparklesIcon} />
                    <p>It’s important for patients to know what the providers believe in and how they will treat patients before committing to a specific one.</p>
                </div>
                <Form
                    form={form}
                    layout="vertical"
                    className={s.form}
                >
                    <div className="flex gap-4">
                        <Form.Item
                            name="treatmentPhilosophy"
                            className="flex-1"
                        >
                            <AiTextEditor
                                type={EAIEditorType.TREATMENT_PHILOSOPHY}
                                maxLength={800}
                                showCount
                                conversionId={conversationId}
                            />
                        </Form.Item>
                    </div>
                </Form>
            </>
        );
    };

    const renderReview = () => {
        return (
            <div className={s.row}>
                <div
                    className={s.displayItem}
                >
                    <div className={s.label}>Treatment philosophy</div>
                    {
                        initValue ?
                            <div
                                className={s.value}
                                dangerouslySetInnerHTML={{
                                    __html: initValue || '',
                                }}
                            /> :
                            EMPTY_PLACEHOLDER
                    }
                </div>
            </div>
        );
    };

    return (
        <div className="mt-2">
            {isEditing ? renderEditing() : renderReview()}
        </div>
    );
});

export default Treatment;
